export const SAMPLES_TO_WIDTH_FACTOR = 3;